module.exports = __webpack_public_path__ + "img/galactica_blueprints_06.2c7ace14.png";